import { FC, useState } from "react";
import { FaAngleDown } from "react-icons/fa";
import active from "../../../assets/images/approveTick.svg";
import { CSSProperties } from "styled-components";
import inactive from "../../../assets/images/inactive.svg";
import { Popover } from "../../../components/ui";
import { useUIPermissions } from "../../../layout/config/permissionUtils";
const marketStatusList = [
  { label: "Active", value: "ACTIVE", icon: active },
  {
    label: "InActive",
    value: "INACTIVE",
    icon: inactive,
  },
];

const MarketStatusDropdown: FC<{
  marketStatus: string;
  onChangeMarketStatus: (status: string) => void;
  roleType: string;
  style?: CSSProperties;
  activeMarketTab?: string;
}> = ({
  marketStatus,
  onChangeMarketStatus,
  roleType,
  style,
  activeMarketTab,
}) => {
  const { hasAdminManagerEditAccess } = useUIPermissions();
  const [open, setOpen] = useState(false);

  return (
    <>
      {hasAdminManagerEditAccess ? (
        <Popover
          open={open}
          onClose={() => setOpen(false)}
          fullWidth={true}
          element={
            <div
              onClick={() => {
                if (activeMarketTab === "ALL") {
                  setOpen(true);
                }
              }}
              className="bg-white p-4 rounded-lg flex items-center gap-4 justify-between w-full cursor-pointer"
              // style={cardStyles}
            >
              <div className="flex items-center gap-2">
                <div className=" relative">
                  <img
                    src={marketStatus == "ACTIVE" ? active : inactive}
                    alt=""
                    className="w-8 h-5"
                  />
                </div>
                <div className="w-full">
                  <h1 className="taxt-base font-bold">{marketStatus}</h1>
                </div>
              </div>
              <FaAngleDown className="ml-auto" />
            </div>
          }
        >
          <div>
            {marketStatusList.map((tradeStatus) => (
              <div
                key={tradeStatus.value}
                className="flex items-center px-4 py-2 gap-4 cursor-pointer hv-primary"
                onClick={() => {
                  onChangeMarketStatus(tradeStatus.value);
                  setOpen(false);
                }}
              >
                <img src={tradeStatus.icon} className="w-5 h-5" alt="" />
                <span className="fs-14">{tradeStatus.label}</span>
              </div>
            ))}
          </div>
        </Popover>
      ) : (
        <div
          className="bg-white p-4 rounded-lg  flex items-center gap-4"
          // style={cardStyles}
        >
          <div className="flex items-center relative">
            <img src={marketStatus == "ACTIVE" ? active : inactive} alt="" />
          </div>
          <div className="w-full">
            <h1 className="text-base font-bold">{marketStatus}</h1>
          </div>
        </div>
      )}
    </>
  );
};
export default MarketStatusDropdown;
